import { Component, Input, OnInit, Output,EventEmitter,SimpleChanges, ViewChild, OnChanges, ViewEncapsulation } from '@angular/core';
import { Campaign3KontableComponent } from 'app/views/campaign-3/components/campaign-3-kontable/campaign-3-kontable.component';

import { DistributionCluster3, DistributionList3, DistributionListCluster, DistributionListDetails } from 'app/views/campaign-3/models/campaign-3.model';
import { DistributionList3Service } from '../services/distribution3.service';
import { single } from 'rxjs/operator/single';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';

@Component({
  selector: 'app-search-distribution-cluster',
  templateUrl: './search-distribution-cluster.component.html',
  styleUrls: ['./search-distribution-cluster.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SearchDistributionClusterComponent implements OnInit {

  //TODO mappare le nuove celassi per entità3!
  
  @Output() distributionListSelected: EventEmitter<Array<DistributionCluster3>> = new EventEmitter<Array<DistributionCluster3>>();
  @Output() closeClusterAdd: EventEmitter<any> = new EventEmitter<any>();
  @Input() searchedClusters: Array<DistributionCluster3>;
  @Input() fatherDistribution: DistributionList3;
  paginationType: number = Campaign3KontableComponent.ServerPagination;
  clustersToAdd: Array<number> = [];
  dateFilter = Campaign3KontableComponent.DateFilter;
  numberFilter = Campaign3KontableComponent.NumberFilter;
  textFilter = Campaign3KontableComponent.TextFilter;
  selectFilter = Campaign3KontableComponent.SelectFilter;
  noFilter = Campaign3KontableComponent.NoFilter;

  
  /* paginationType: number = Campaign3KontableComponent.NoPagination; */
  show = {
    table: false
  }
  
  constructor(
    private distributionService: DistributionList3Service
    ) {
  
  }
  ngOnInit() {
    this.show.table = true;
  }
  @Output() closeClusterAndRefresh: EventEmitter<any> = new EventEmitter<any>();
  onClickAddClusters() {
  
    if (this.clustersToAdd.length > 0) {
      this.distributionService.onAddSelectedClusters(this.fatherDistribution.distributionListId, this.clustersToAdd).subscribe(
        res => {
          if (res) {
            this.clustersToAdd = []; // Svuota la lista dopo l'aggiunta
            this.closeClusterAndRefresh.emit(true);
          }
        },
        error => {
          console.error("Errore durante l'aggiunta dei cluster:", error);
        }
      );
    } else {
      console.error("Nessun elemento selezionato");
    }
  }
  
  onClickUndoSelection() {
    this.clustersToAdd = []; // Svuota la lista di elementi selezionati
    this.closeClusterAdd.emit(true);

  }
  


onClusterElementSelected(data) {
  const singleId = data.id;
  if (singleId >= 0) {
    const index = this.clustersToAdd.indexOf(singleId);
    if (index === -1) {
      this.clustersToAdd.push(singleId);
    } else {
      this.clustersToAdd.splice(index, 1);
    }
  }
}

}



// WEBPACK FOOTER //
// ./src/app/views/distribution-list/search-distribution-cluster/search-distribution-cluster.component.ts